import {store} from "../store/store.js";
const setHeaders = (token = null, tenantId = null, extraHeaders = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...extraHeaders,
  };

  const state = store.getState();
  const accessToken = state.auth.accessToken;

  if (token) {
    headers["Authorization"] = accessToken;
  }

  if (tenantId) {
    headers["X-TenantID"] = tenantId;
  }

  return headers;
};

export { setHeaders };
